import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import TechStepperContainer from '../../containers/techmng/stepper/TechStepperContainer';

const TechStepPage = () => {
  const { id, step, tab } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [activeTap, setActiveTap] = useState(0);
  let navigate = useNavigate();

  useEffect(() => {
    if (step) {

      setActiveStep(Number(step));
      //  console.log(step,'step');
    }
    if (tab) {
      setActiveTap(Number(tab - 1));
      // console.log(tab,'tab');
    }
  }, [id, step, tab]);

  const handleTabChange = (event, newValue) => {
    // console.log('handleTabChange', newValue);
    // setActiveTap(newValue);
    let newStep = newValue + 1;
    navigate(`/techmng/${id}/${step}/${newStep}`);
  }

  const handleGoBack = () => {
    navigate('/techmng')
  }

  return (
    <Box
      sx={{
        mt: 2,
        mx: 2,
      }}
    >
      <TechStepperContainer
        activeStep={activeStep} activeTap={activeTap} handleTabChange={handleTabChange} handleGoBack={handleGoBack} />
    </Box>
  );
};

export default TechStepPage;
